import { useState, useEffect } from "react";

// Base API relativa: funziona su qualsiasi dominio; in dev Vite fa da proxy (vedi vite.config.js).
const wsurl = "/api/index.php?p=";

/* ----------------------------------------------------------- sessione --- */
// Se il server risponde 401 la sessione è scaduta o è stata revocata: l'app
// deve tornare al login ovunque ci si trovi, non mostrare un errore generico.
let unauthorizedHandler = null;
const setUnauthorizedHandler = (fn) => { unauthorizedHandler = fn; };
const checkAuth = (response) => {
  if (response.status === 401) {
    // col contratto scaduto il server dice perché: lo si mostra nella schermata di accesso
    response.clone().json()
      .then((d) => unauthorizedHandler?.(d?.codice === 'contratto' ? d.error : null))
      .catch(() => unauthorizedHandler?.(null));
    throw new Error("sessione scaduta");
  }
  return response;
};

/** Chiamata JSON con errore parlante: usa il messaggio del server, non "HTTP 400". */
async function apiJson(path, { method = "GET", body } = {}) {
  const res = await fetch(wsurl + path, {
    method,
    headers: body === undefined ? { Accept: "application/json" } : { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  let data = null;
  try { data = await res.json(); } catch { /* risposta senza corpo */ }
  if (!res.ok) {
    const err = new Error(data?.error || `Errore ${res.status}`);
    err.status = res.status;
    err.codice = data?.codice;
    // sessione finita durante l'uso (anche per contratto scaduto): si torna all'accesso
    if (res.status === 401 && path !== '/me' && path !== '/login')
      unauthorizedHandler?.(data?.codice === 'contratto' ? data.error : null);
    throw err;
  }
  return data;
}

const auth = {
  // 401 qui è normale (nessuna sessione): non deve far scattare il redirect globale
  // col contratto scaduto l'errore passa, per mostrare il motivo nella schermata di accesso
  me:       () => apiJson("/me").catch((e) => (e.status === 401 && e.codice !== 'contratto' ? null : Promise.reject(e))),
  login:    (username, password) => apiJson("/login", { method: "POST", body: { username, password } }),
  logout:   () => apiJson("/logout", { method: "POST", body: {} }),
  cambiaPassword: (nuova, vecchia) => apiJson("/password", { method: "POST", body: { nuova, vecchia } }),
  // "Non ricordi la password?": link via email, sua verifica, nuova password
  passwordDimenticata: (utente) => apiJson("/password-dimenticata", { method: "POST", body: { utente } }),
  verificaReset:  (token) => apiJson(`/reimposta&token=${encodeURIComponent(token)}`),
  reimposta:      (token, nuova) => apiJson("/reimposta", { method: "POST", body: { token, nuova } }),
  utenti:   () => apiJson("/utenti"),
  creaUtente:     (u) => apiJson("/utenti", { method: "POST", body: u }),
  aggiornaUtente: (u) => apiJson("/utenti", { method: "PUT", body: u }),
  // concessionari registrati (per chi vede tutto): riconosciuti nei titoli e nei filtri
  concessionari:  () => apiJson("/concessionari"),
  // aziende e assegnazione degli impianti ai concessionari (solo amministratori)
  aziende:        () => apiJson("/aziende"),
  creaAzienda:    (a) => apiJson("/aziende", { method: "POST", body: a }),
  aggiornaAzienda:(a) => apiJson("/aziende", { method: "PUT", body: a }),
  assegna:        (ids, aziendaId) => apiJson("/assegna", { method: "POST", body: { ids, aziendaId } }),
  assegnaPerTitolo: (aziendaId, prefisso, conferma) =>
    apiJson("/assegna-per-titolo", { method: "POST", body: { aziendaId, prefisso, conferma } }),
  // eliminazione su approvazione: chi non è amministratore la chiede (o la ritira), l'amministratore decide
  chiediEliminazione: (id, motivo) => apiJson("/richiesta-eliminazione", { method: "POST", body: { id, motivo } }),
  ritiraEliminazione: (id) => apiJson("/richiesta-eliminazione", { method: "DELETE", body: { id } }),
  decidiEliminazione: (richiesta, approva) =>
    apiJson("/richieste-eliminazione", { method: "POST", body: { richiesta, approva } }),
};

function MIMEURLToByte(imgurlb64){
    let mime = imgurlb64.split(',')[1];
    return mime;
  }
const getFromDB = (cb, cberr)=>{
    fetch(wsurl+"/cartellone",{
        method:"GET",
        headers:{
          "Accept":"application/json",
        },
    }).then(checkAuth).then((response)=>{
        if(!response.ok) throw new Error("HTTP "+response.status);
        return response.json();
    })
    .then((posarray)=>{
        cb(posarray);
    }).catch((error)=>{
        if(cberr) cberr(error);
    });
}
const delToDB = (cartellone,busyfunction,logfunction,cb) =>{
  busyfunction(true);
  fetch(wsurl+"/cartellone",{
      method:"DELETE",
      headers:{
        "Content-Type":"application/json",
      },
      body: JSON.stringify(cartellone)
  }).then(checkAuth).then((response)=>{ if(!response.ok) throw new Error("HTTP "+response.status); return response.json(); })
      .then((toolsarray)=>{
      busyfunction(false);
      cb(toolsarray);
  }).catch((error)=>{
      busyfunction(false);
      logfunction("errore ");
  });

};

const putToDB = (cartellone,busyfunction,logfunction,cb) =>{
  busyfunction(true);
  fetch(wsurl+"/cartellone",{
      method:"PUT",
      headers:{
        "Content-Type":"application/json",
      },
      body: JSON.stringify(cartellone)
  }).then(checkAuth).then((response)=>{ if(!response.ok) throw new Error("HTTP "+response.status); return response.json(); })
      .then((toolsarray)=>{
      busyfunction(false);
      cb(toolsarray);
  }).catch((error)=>{
      busyfunction(false);
      logfunction("errore ");
  });

};

const postNewCap = (imagesrc, cartelid, busyfunction,cb,cberr) =>{
  const addelem = {cid:cartelid,imgsrc:imagesrc};

  busyfunction(true);

  fetch(wsurl+"/cntx",{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
      },
      body: JSON.stringify(addelem)
  }).then(checkAuth).then((response)=>{ if(!response.ok) throw new Error("HTTP "+response.status); return response.json(); })
      .then((elem)=>{
      busyfunction(false);
      cb(elem);
  }).catch((error)=>{
      busyfunction(false);
      if(cberr) cberr(error);
  });

};

const postTitle = (cartellone,logfunction,cb) =>{
  fetch(wsurl+"/title",{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
      },
      body: JSON.stringify(cartellone)
  }).then(checkAuth).then((response)=>{ if(!response.ok) throw new Error("HTTP "+response.status); return response.json(); })
      .then((elem)=>{
      logfunction("success");
  }).catch((error)=>{
      logfunction("errore ");
  });

};

const postToDB = (cartellone,busyfunction,logfunction,cb) =>{
    busyfunction(true);
    fetch(wsurl+"/cartellone",{
        method:"POST",
        headers:{
          "Content-Type":"application/json",
        },
        body: JSON.stringify(cartellone)
    }).then(checkAuth).then((response)=>{ if(!response.ok) throw new Error("HTTP "+response.status); return response.json(); })
        .then((elem)=>{
        busyfunction(false);
        cb(elem);
    }).catch((error)=>{
        busyfunction(false);
        logfunction("errore ");
    });

  };

  const postForCsvs = (ids,busyfunction,logfunction,cb) =>{
    fetch(wsurl+"/csv",{
        method:"POST",
        headers:{
          "Content-Type":"application/json",
        },
        body: JSON.stringify(ids)
    }).then(checkAuth).then((response)=> response.text())
        .then((csvfile)=>{
          var anchor = document.createElement('a');
          anchor.download = "selected.csv";
          if(window.URL.createObjectURL) {
            var blobObject = new Blob([csvfile], {type: 'text/csv'});
            anchor.href = window.URL.createObjectURL(blobObject);
            anchor.click();
          }
    }).catch((error)=>{
    });

  };

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
  }

  export {wsurl, auth, setUnauthorizedHandler, postTitle, postNewCap, postForCsvs, putToDB, delToDB, getFromDB, MIMEURLToByte, postToDB, getWindowDimensions,useWindowDimensions};
